import { GlobalOutlined } from "@ant-design/icons";
import { Badge, Button, Tooltip } from "antd";

function GlobalBanButton({
	handleClick,
	is24H,
	isLoading
}: { handleClick: () => void; is24H: boolean, isLoading: boolean }) {
	return (
    <Tooltip title={is24H ? "24-hour Global Ban" : "Global Ban"}>
		<Badge
			count={is24H ? "24h" : ""}
			style={{
            	width: 16,
            	height: 16,
				borderRadius: "100%",
            	fontSize: 7,
            	alignItems: 'center',
			}}
          	offset={[-5, 5]}
		>
			<Button
				variant="outlined"
				onClick={handleClick}
				icon={<GlobalOutlined />}
				loading={isLoading}
			/>
		</Badge>
    </Tooltip>
	);
}

export default GlobalBanButton;
